import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { AuthoritySettingsSection } from '../components/settings/authority-section.js';

const parentRoute = getRouteApi('/brand/$slug/settings');

export const Route = createFileRoute('/brand/$slug/settings/authority')({
  component: AuthorityPage,
});

function AuthorityPage() {
  const { brand } = parentRoute.useLoaderData();
  return <AuthoritySettingsSection brand={brand} />;
}
